import { Access } from "../components/ui/Access";
import { BottomCTA } from "../components/ui/BottomCTA";
import { bottomCTA } from "../../datasets/blog/bottomCTA";

export const AwsCaseStudy = ({ title, content }) => {
  return (
    <>
      {title && content && (
        <>
          <section className="blog_post-main">
            {content.body.length !== 0 && (
              <section className="post_body-background">
                <section className="section-layout">
                  <section className="post_body-main">
                    <h1 className="post_body-header aws">{title}</h1>
                    {content?.featured_image && (
                      <div className="post_body-image">
                        <img src={content.featured_image.src} alt="" />
                      </div>
                    )}
                    <div
                      className="post_body-content"
                      dangerouslySetInnerHTML={{ __html: content.body }}
                    />
                  </section>
                </section>
              </section>
            )}
          </section>
        </>
      )}
      <Access skewed />
      <BottomCTA data={bottomCTA} />
    </>
  );
};
